import { configureStore, combineReducers } from '@reduxjs/toolkit'
import appConfigReducer from './features/init/masterdata/masterDataSlice'
import navigationReducer from './features/navigation/navigation-slice'
import customerDataReducer from './features/customers/customer-slice'
import currentSyncReducer from './features/reduxSlices/current-sync-slice'
import currentOfferReducer from './features/currentOffer/current-offer-slice'
import opportunitiesReducer from './features/customers/opportunity-slice'
import toastSlice from './features/notification/toast-slice'
import bannerReducer from './features/notification/banner-slice'
import equipmentList from './features/prepare/equipment/equipment-list-slice'
import assetStatusDetailsReducer from './features/prepare/equipment/asset-details-slice'
import equipmentModalReducer from './features/prepare/equipment/equipment-modal-slice'
import equipmentSelectionReducer from './features/prepare/equipment/equipment-selection-slice'
import locationModalReducer from './features/prepare/location/location-modal-slice'
import contactListReducer from './features/prepare/contact/contact-list-slice'
import groupingReducer from './features/grouping/grouping-slice'
import alertReducer from './features/notification/alert-slice'
import unSavedOfferCountReducer from './features/currentOffer/unsaved-offer-slice'
import syncInProgressReducer from './features/sync/sync-slice'
import baseConfigReducer from './features/baseConfig/base-config-slice'
import appInitializationReducer from './features/init/app-initialized-slice'
import serviceConfigurationReducer from './features/serviceConfiguration/service-configuration-slice'
import offeringReducer from './features/offering/offering-slice'
import tenderFinalizationReducer from './features/tenderFinalization/tender-finialization-slice'

const appInitializationReducers = {
  baseConfig: baseConfigReducer,
  configdata: appConfigReducer,
  customers: customerDataReducer,
  appInitialized: appInitializationReducer
}

const notificationReducers = {
  toast: toastSlice,
  banner: bannerReducer,
  alert: alertReducer
}

const prepareReducers = {
  equipmentList,
  assetStatusDetails: assetStatusDetailsReducer,
  equipmentModal: equipmentModalReducer,
  equipmentSelection: equipmentSelectionReducer,
  locationModal: locationModalReducer,
  contactList: contactListReducer
}

const appReducer = combineReducers({
  ...appInitializationReducers,
  ...notificationReducers,
  ...prepareReducers,
  groupDetails: groupingReducer,
  navigation: navigationReducer,
  currentSync: currentSyncReducer,
  currentOffer: currentOfferReducer,
  opportunities: opportunitiesReducer,
  unSavedOfferCount: unSavedOfferCountReducer,
  syncInProgress: syncInProgressReducer,
  serviceConfiguration: serviceConfigurationReducer,
  offeringDetails: offeringReducer,
  tenderFinalization: tenderFinalizationReducer
})

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STORE') {
    state = undefined
  }
  return appReducer(state, action)
}

const Store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 128,
        // Ignore these action types
        ignoredActions: ['alert/showAlert', 'navigation/setUnsavedChangesWarning'],
        // Ignore these paths in the state
        ignoredPaths: [
          'alert.onPrimaryClick',
          'alert.onSecondaryClick',
          'alert.onClose',
          'alert.description',
          'alert.primaryButtonContent',
          'alert.secondaryButtonContent',
          'navigation.onDiscardChanges'
        ]
      }
    })
})
export default Store

export const resetStore = () => ({ type: 'RESET_STORE' })

export type RootState = ReturnType<typeof Store.getState>
export type AppDispatch = typeof Store.dispatch
